import { Component } from 'opus-angular-seed-core';

// Unique ID counter for action menu instances
let actionMenuIdCounter = 0;

@Component({
    bindings: {
        buttonLabel: '@',
        isOpen: '=?',
        onToggle: '&?',
        disabled: '<?',
        menuStyle: '<?'
    },
    transclude: true,
    template: `
        <div class="action-menu" ng-class="{ open: vm.isOpen }" ng-style="vm.menuStyle">
            <button aria-haspopup="true"
                    aria-expanded="{{ vm.isOpen }}"
                    ng-click="vm.toggle($event)"
                    ng-disabled="vm.disabled">
                <span>{{ vm.buttonLabel || 'Actions' }}</span>
            </button>
            <ul role="menu" ng-if="vm.isOpen" ng-transclude></ul>
        </div>
    `
})
export default class {
    constructor ($document, $scope, $rootScope) {
        this.$document = $document;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this._outsideClickHandler = null;
        this._menuId = ++actionMenuIdCounter;
        this._closeListener = null;
    }

    $onInit () {
        if (typeof this.isOpen === 'undefined') {
            this.isOpen = false;
        }

        // Listen for other action menus opening
        this._closeListener = this.$rootScope.$on('actionMenu:open', (event, menuId) => {
            if (menuId !== this._menuId && this.isOpen) {
                this.close();
            }
        });
    }

    toggle ($event) {
        if ($event) {
            $event.stopPropagation();
        }
        const wasOpen = this.isOpen;
        this.isOpen = !wasOpen;

        if (this.onToggle) {
            this.onToggle({ isOpen: this.isOpen });
        }

        if (!wasOpen) {
            // Broadcast that this menu is opening so others close
            this.$rootScope.$emit('actionMenu:open', this._menuId);
            this._bindOutsideClick();
        }
        else {
            this._unbindOutsideClick();
        }
    }

    close () {
        if (this.isOpen) {
            this.isOpen = false;
            if (this.onToggle) {
                this.onToggle({ isOpen: false });
            }
            this._unbindOutsideClick();
        }
    }

    _onOutsideClick (event) {
        const actionMenu = event.target.closest('.action-menu');
        if (!actionMenu) {
            this.$scope.$apply(() => {
                this.close();
            });
        }
    }

    _bindOutsideClick () {
        if (!this._outsideClickHandler) {
            this._outsideClickHandler = (event) => {
                this._onOutsideClick(event);
            };
            this.$document.on('click', this._outsideClickHandler);
        }
    }

    _unbindOutsideClick () {
        if (this._outsideClickHandler) {
            this.$document.off('click', this._outsideClickHandler);
            this._outsideClickHandler = null;
        }
    }

    $onDestroy () {
        this._unbindOutsideClick();
        if (this._closeListener) {
            this._closeListener();
            this._closeListener = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/actionMenu/index.js